enum FitAssistantStatusIcon {
  NoSelection = 'le-icon-car',
  NoSelectionRoofRack = 'le-icon-car-roof-rack',
  Confirmed = 'le-icon-check-circle',
  Unconfirmed = 'le-icon-alert-circle',
  NoFit = 'le-icon-x-circle',
}

export default FitAssistantStatusIcon;
